/* =========================================================================
   RRC Cart helpers — patch a Dawn quirk where the cart drawer's "Estimated
   total" doesn't always re-render after a quantity change. We listen for
   Dawn's pub-sub cart update event, fetch the fresh /cart.js, and overwrite
   any visible total/subtotal element with the current value.

   Targets every element matching the selectors below — works for both the
   cart drawer (rrc-design.css restyles it) and the /cart page.
   ========================================================================= */
(function () {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshTotalsFromCart(cart) {
    if (!cart) return;
    var price = formatMoney(cart.total_price);
    document.querySelectorAll('.totals__total-value, .totals__subtotal-value, [data-rrc-cart-total]').forEach(function (el) {
      el.textContent = price;
    });
    // Also bump the header bag count, in case the header listener missed it.
    var countEl = document.getElementById('RrcCartCount');
    if (countEl) {
      countEl.setAttribute('data-count', cart.item_count);
      countEl.textContent = cart.item_count;
    }
  }

  function fetchAndRefresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(refreshTotalsFromCart)
      .catch(function () { /* silently ignore — Dawn will eventually catch up */ });
  }

  // Subscribe to Dawn's cart update bus if available.
  function wire() {
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (payload && payload.cartData && typeof payload.cartData.total_price === 'number') {
          refreshTotalsFromCart(payload.cartData);
        } else {
          fetchAndRefresh();
        }
      });
    }
    // Also catch direct quantity-input edits inside the drawer / cart page.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT') return;
      if (t.name === 'quantity' || t.classList.contains('quantity__input')) {
        // Wait a tick for Dawn's POST to /cart/change.js to land, then refresh.
        setTimeout(fetchAndRefresh, 300);
      }
    });
    // Same for the +/- buttons (they don't fire `change` until the input blurs).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quantity__button');
      if (!btn) return;
      setTimeout(fetchAndRefresh, 350);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
